import { render, staticRenderFns } from "./BaseModalWindow.vue?vue&type=template&id=67521085&"
import script from "./BaseModalWindow.vue?vue&type=script&lang=ts&"
export * from "./BaseModalWindow.vue?vue&type=script&lang=ts&"
import style0 from "./BaseModalWindow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports